import {Component, OnInit, ViewChild} from "@angular/core";
import {UntypedFormBuilder, UntypedFormGroup, Validators} from "@angular/forms";
import { Observable,throwError } from 'rxjs';
import {ChangePassword} from "./ChangePassword";
import {LogService} from "../Abstract/log.service";
import {ConfigService} from "../../Core/Abstract/config.service";
import {EventsEmitterService} from "../../Core/Abstract/emitter.service";
import {PasswordValidatorOptions, passwordValidator} from "./passwordValidator.component";
import {matchOtherValidator} from "./matchOtherValidator.component";
import {ChangePasswordService} from "./changePassword.service";
import { ActivatedRoute } from "@angular/router";
import { SecurityService } from '../../Core/Security/security.service';
import { ModalDirective } from 'ngx-bootstrap/modal';

@Component({
    selector: 'changePassword',
    templateUrl: 'changePassword.component.html',
    providers: [ChangePasswordService]
})

export class ChangePasswordComponent implements OnInit {

    @ViewChild('changePwdModal',{static: false}) public msgModal: ModalDirective;
    /*
     *  Modal handling
     */

    public showChildModal(): void {
        this.msgModal.show();
    }

    public hideChildModal(): void {
        this.msgModal.hide();
    }

    public email =  /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

    private loading: boolean = false;
    private pwdmodel = {
        username: localStorage.getItem('changePassword') ,
        oldPassword:'',
        newPassword:'',
        matchNewPassword:'',

    };    
    private regexList:Array<PasswordValidatorOptions> = [];
    private rulesArray:Array<Object> = [];

    private isLoggedIn: boolean;
    private pwdForm: UntypedFormGroup;
    private validationMessages= {};
    private redirectMsg : String;
    private redirectTitle = 'Success';
    private formErrors = {
        'username' : '',
        'oldPassword': '',
        'newPassword': '',
        'matchNewPassword': ''
    };

    pwderror = false;
    pwdmsg = "";
    footerMsg = "";
    public barLabel: string = "";

    constructor(private changePasswordService: ChangePasswordService,private securityService : SecurityService, private logger: LogService, private fb: UntypedFormBuilder,
                private configService: ConfigService, private eventsEmitterService :EventsEmitterService,protected route: ActivatedRoute) {
    }

    ngOnInit(): void {
        if (localStorage.getItem("access_token") === null) {
            this.isLoggedIn = false
          }
          else{
            this.isLoggedIn = true
          }
       this.buildForm();
       this.getRules();
       this.footerMsg = this.configService.getFooter();
    }

    protected getRules(): void {
        this.changePasswordService.getRules().subscribe(
            data => {
                this.logger.log(data);
                this.rulesArray = data;
                this.rulesArray.forEach(rule => {
                    //this.logger.log(rule);
                    if(rule['regex'] != null && rule['regex'] != ''){
                        this.regexList.push(new PasswordValidatorOptions(new RegExp(rule['regex']), rule['name']));
                    }
                });
                
            },
            error => {
                this.logger.log("Could not get pass rules!");
                this.changePasswordService.goToLogin();
            }
        );
    }

    private buildForm() {
        this.pwdForm = this.fb.group({
            'username' : [{value:this.pwdmodel.username, 'disabled':true}, []],
            'oldPassword': [this.pwdmodel.oldPassword, [Validators.required, passwordValidator(this.regexList)]],
            'newPassword': [this.pwdmodel.newPassword, [Validators.required, passwordValidator(this.regexList)]],
            'matchNewPassword': [this.pwdmodel.matchNewPassword, [Validators.required, matchOtherValidator('newPassword')]]
        })

        this.validationMessages = {
            'username': {
                'required': 'Required field'
            },
            'oldPassword': {
                'required': 'Required field'
            },
            'newPassword': {
                'required': 'Required field',  
            },
            'matchNewPassword': {
                'required': 'Required field',
                'matchOther': 'Passwords do not match'
            }
        };

        this.pwdForm.valueChanges.subscribe(data => this.onValueChanged(data));

        this.onValueChanged();
    }

    /*
     *  Different impl with formErrors as Array<string>
     */
    onValueChanged(data?: any) {
        if (!this.pwdForm) { return; }
        
        //set custom regex visuals here
        //cannot move this in build form, messages are empty 
        this.rulesArray.forEach(rule => {
            if(rule['regex'] != null && rule['regex'] != ''){
                this.validationMessages['newPassword'][rule['name']] = rule['message'] || 'Password not matching criteria';
                this.validationMessages['oldPassword'][rule['name']] = rule['message'] || 'Password not matching criteria';
            }
        });

        const form = this.pwdForm;
        //this.logger.log(this.pwdForm);
        for (const field in this.formErrors) {
            // clear previous error message (if any)
            this.formErrors[field] = [];
            const control = form.get(field);

            if (control && control.dirty && !control.valid) {
                const messages = this.validationMessages[field];
                //this.logger.log(control.errors)
                for (const key in control.errors) {
                    this.formErrors[field].push(messages[key]);
                }
            }
        }
        // this.logger.log("formerrors: " + JSON.stringify(this.formErrors));
    }

    public returnToLogin(){
        this.changePasswordService.goToLogin();
    }

    public doChangePassword(pwdmodel: ChangePassword){
        this.loading = true;
        this.pwderror = false;
        if (this.isLoggedIn){
            this.changePasswordService.changePasswordRequest(pwdmodel).subscribe(
                data => {
                    LogService.emitAlert({
                        type: "success",
                        body: data.data
                    });
                    this.redirectMsg = data.data;
                    this.showChildModal();
                    this.loading = false;
                },
                error => {
                    this.loading = false;
                    this.pwderror = true;
                    this.pwdmsg = error.error.message;
                    LogService.emitAlert({
                        type: "danger",
                        body: this.pwdmsg
                    });
                    this.logger.error(error);
                    return throwError(error);
                }
                
            );
        }else{
            this.changePasswordService.updatePasswordRequest(pwdmodel).subscribe(
                data => {
                    LogService.emitAlert({
                        type: "success",
                        body: data.data
                    });
                    this.redirectMsg = data.data;
                    this.showChildModal();
                    this.loading = false;
                },
                error => {
                    this.loading = false;
                    this.pwderror = true;
                    this.pwdmsg = error.error.message;
                    LogService.emitAlert({
                        type: "danger",
                        body: this.pwdmsg
                    });
                    this.logger.error(error);
                    return throwError(error);
                }
                
            );
        }
    }
}